type EstimateReferenceLike = {
    estimate_id?: number;
    estimate_no?: string;
    estimate_ref?: string;
    revision_no?: number;
    root_estimate_id?: number;
    parent_estimate_id?: number;
};

const padEstimateId = (id: number) => String(id).padStart(4, '0');

export function getEstimateBaseNo(estimate?: EstimateReferenceLike | null): string {
    if (!estimate) return '';
    const providedBase = String(estimate.estimate_no || '').trim();
    if (providedBase) return providedBase;

    const rootId = Number(estimate.root_estimate_id || estimate.parent_estimate_id || estimate.estimate_id || 0);
    return rootId > 0 ? `HC/EST/${padEstimateId(rootId)}` : '';
}

export function getEstimateRef(estimate?: EstimateReferenceLike | null): string {
    if (!estimate) return '';
    const providedRef = String(estimate.estimate_ref || '').trim();
    if (providedRef) return providedRef;

    const baseNo = getEstimateBaseNo(estimate);
    if (!baseNo) return '';

    const revisionNo = Number(estimate.revision_no || 0);
    return revisionNo > 0 ? `${baseNo}/R${revisionNo}` : baseNo;
}
